import { useState, useEffect } from "react";
import { useSignal } from "@preact/signals-react";

import Screen from "componentsv2/board/Screen";
import Board from "componentsv2/board/Board";
import PanelCharts from "./PanelCharts";
import ActiveRooms from "./ActiveRooms";
import Promotion from "./Promotion";
import { layout as modelBooking } from "./models/modelBooking";
import { getStorage, setStorage } from "store/local";
import { useStoreProducts } from "./storeProducts";
import proxy from "api/proxy";

function ScreenBooking() {
  const view = useSignal("list");
  const [displayOpen, setDisplayMode] = useState(true);
  const [filterDay, setFilterDay] = useState(new Date());
  const [checkData, setCheckData] = useState([]);
  const [occRate, setOccRate] = useState({});
  const [occRoom, setOccRoom] = useState({});
  const { setProducts } = useStoreProducts();
  const localStore = getStorage("ctxSession");
  // const [lastReservations, setLastReservations] = useState([]);
  // const [guestsData, setGuestsData] = useState([]);

  useEffect(() => {
    // getBookings();
    getCheckInfo();
    getOccRate();
    setHotelConfig();
    setShop();
    setProducts();
  }, [filterDay]);

  function onChangeDate(value) {
    setFilterDay(value);
  }

  // async function getBookings() {
  //   const filterDayFmt = format(filterDay, "yyyy-MM-dd");
  //   const newDomain = [["lines.arrival_date", "=", filterDayFmt]];
  //   newCtxView.domain = newDomain;
  //   setNewCtxView(newCtxView);
  // }

  function handleDisplay(mode) {
    setDisplayMode(mode);
  }

  // async function getLastReservations() {
  //   const dom = [];
  //   const order = [["id", "DESC"]];
  //   const limit = 5;
  //   const { data } = await proxy.search(MODEL, dom, fields, limit, order);
  //   setLastReservations(data);
  // }

  async function getCheckInfo() {
    const argsChecks = {
      model: "hotel.folio",
      method: "checks_info",
      args: [{ shop: localStore.shop }],
    };
    const { data: checks } = await proxy.methodCall(argsChecks);
    setCheckData(checks);

    // const argsGuests = {
    //   model: "hotel.folio",
    //   method: "guests_info",
    //   args: [],
    // };
    // const { data: guests } = await proxy.methodCall(argsGuests);
    // setGuestsData(guests);
  }

  async function getOccRate() {
    const argsOcc = {
      model: "hotel.folio",
      method: "occ_rate_info",
      args: [{ shop: localStore.shop }],
    };
    const { data } = await proxy.methodCall(argsOcc);

    setOccRate({
      title: "hotel.chart.occupation_today",
      elements: [data.occ_room_today, data.occ_rate_today],
    });
    setOccRoom({
      title: "hotel.chart.occupation_tomorrow",
      elements: [data.occ_room_tomorrow, data.occ_rate_tomorrow],
    });
  }

  async function setHotelConfig() {
    const hotelConfig = getStorage("hotelConfig");
    if (!hotelConfig) {
      const { data } = await proxy.search(
        "hotel.configuration",
        [],
        [
          "nationality.rec_name",
          "nationality.code",
          "taxes_auth.rec_name",
          "payment_term.name",
        ],
      );
      if (data) {
        setStorage("hotelConfig", data[0]);
      }
    }
  }

  // function currentView(viewType) {
  //   view.value = viewType;
  // }

  async function setShop() {
    const ctxSession = getStorage("ctxSession");
    const { shop } = ctxSession;
    // ESTO ES TOTALMENTE INNECESARIO ????
    if (shop) {
      const { data } = await proxy.search(
        "sale.shop",
        ["id", "=", shop],
        ["name"],
      );
      if (data) {
        setStorage("hotelShop", data[0]);
      }
    }
  }

  let styleScreen = "w-full md:w-full lg:w-4/5 xl:w-3/5";
  if (view.value === "list") {
    styleScreen = "w-full md:w-4/5 lg:w-4/5 xl:w-4/5";
  } else {
    styleScreen = "w-full";
  }

  return (
    <div id="screen-hotel-booking" className="flex w-full">
      <Screen style={styleScreen}>
        {view.value === "list" && (
          <PanelCharts
            occRate={occRate}
            checkData={checkData}
            occRoom={occRoom}
          />
        )}
        <div className="flex">
          <Board
            layout={modelBooking()}
            onChangeDate={onChangeDate}
            currentView={view}
          />
        </div>
      </Screen>
      {view.value === "list" && <ActiveRooms />}
    </div>
  );
}
// {view.value === "form" && <Promotion />}

export default ScreenBooking;
